import React from 'react';
import { Link } from 'react-router-dom';
import Arrow from 'react-icons/lib/fa/arrow-left';

const More =({path})=>{
    return(
        <div className="more-btn cairo-font">
            <Link to={path}><Arrow/> المزيد</Link>
        </div>
    );
}
export default More;


// WEBPACK FOOTER //
// ./src/components/common/More.js